import { css, DefaultTheme } from 'styled-components';

const styles = {
  profileMenuContainer: ({ theme }: { theme: DefaultTheme }) => css`
    width: 230px;

    .profile-name,
    .profile-email {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    ul,
    li {
      padding: 0;
      margin: 0 0 ${theme.spacing.xxs}px 0;
      list-style: none;
    }

    a[aria-disabled='true'] {
      pointer-events: none;
      opacity: 0.5;
      color: ${theme.colors.neutral.palette50};
      &:hover {
        color: ${theme.colors.primary.palette500};
      }
    }

    a:hover {
      color: ${theme.colors.primary.palette500};
    }

    li[role='menuitem'] {
      padding-top: ${theme.spacing['3xs']}px;
    }

    > .sensei-ui-row {
      &:not(:last-child) {
        border-bottom: 1px solid ${theme.colors.neutral.palette500};
        padding: ${theme.spacing.sm}px 0;
      }

      &:last-child {
        padding: ${theme.spacing.xxs}px 0 0 0;
      }
    }
  `,
};

export default styles;
